// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"174":"5d1d5ec9","641":"3f481825"}[chunkId] + ".css";
};